/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    GetAllParcelTemplatesByShippoCarrierPaResponse,
    GetAllServiceLevelsByShippoCarrierPaResponse,
    GetAllShippoCarriersAllInOneResponse,
    GetAllShippoCarriersResponse,
    GetAllSignatureConfirmationsByShippoCarrierPaResponse,
} from '../models';

export interface ShippoCarrierApiControllerGetAllParcelTemplatesByShippoCarrierRequest {
    carrier: string;
}

export interface ShippoCarrierApiControllerGetAllServiceLevelsByShippoCarrierRequest {
    carrier: string;
}

export interface ShippoCarrierApiControllerGetAllSignatureConfirmationsByShippoCarrierRequest {
    carrier: string;
}

/**
 * 
 */
export class ShippoCarrierApi extends runtime.BaseAPI {

    /**
     */
    async shippoCarrierApiControllerGetAllParcelTemplatesByShippoCarrierRaw(requestParameters: ShippoCarrierApiControllerGetAllParcelTemplatesByShippoCarrierRequest): Promise<runtime.ApiResponse<Array<GetAllParcelTemplatesByShippoCarrierPaResponse>>> {
        if (requestParameters.carrier === null || requestParameters.carrier === undefined) {
            throw new runtime.RequiredError('carrier','Required parameter requestParameters.carrier was null or undefined when calling shippoCarrierApiControllerGetAllParcelTemplatesByShippoCarrier.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/shippo-carriers/{carrier}/parcelTemplates`.replace(`{${"carrier"}}`, encodeURIComponent(String(requestParameters.carrier))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async shippoCarrierApiControllerGetAllParcelTemplatesByShippoCarrier(requestParameters: ShippoCarrierApiControllerGetAllParcelTemplatesByShippoCarrierRequest): Promise<Array<GetAllParcelTemplatesByShippoCarrierPaResponse>> {
        const response = await this.shippoCarrierApiControllerGetAllParcelTemplatesByShippoCarrierRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async shippoCarrierApiControllerGetAllServiceLevelsByShippoCarrierRaw(requestParameters: ShippoCarrierApiControllerGetAllServiceLevelsByShippoCarrierRequest): Promise<runtime.ApiResponse<Array<GetAllServiceLevelsByShippoCarrierPaResponse>>> {
        if (requestParameters.carrier === null || requestParameters.carrier === undefined) {
            throw new runtime.RequiredError('carrier','Required parameter requestParameters.carrier was null or undefined when calling shippoCarrierApiControllerGetAllServiceLevelsByShippoCarrier.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/shippo-carriers/{carrier}/serviceLevels`.replace(`{${"carrier"}}`, encodeURIComponent(String(requestParameters.carrier))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async shippoCarrierApiControllerGetAllServiceLevelsByShippoCarrier(requestParameters: ShippoCarrierApiControllerGetAllServiceLevelsByShippoCarrierRequest): Promise<Array<GetAllServiceLevelsByShippoCarrierPaResponse>> {
        const response = await this.shippoCarrierApiControllerGetAllServiceLevelsByShippoCarrierRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async shippoCarrierApiControllerGetAllSignatureConfirmationsByShippoCarrierRaw(requestParameters: ShippoCarrierApiControllerGetAllSignatureConfirmationsByShippoCarrierRequest): Promise<runtime.ApiResponse<Array<GetAllSignatureConfirmationsByShippoCarrierPaResponse>>> {
        if (requestParameters.carrier === null || requestParameters.carrier === undefined) {
            throw new runtime.RequiredError('carrier','Required parameter requestParameters.carrier was null or undefined when calling shippoCarrierApiControllerGetAllSignatureConfirmationsByShippoCarrier.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/shippo-carriers/{carrier}/signatureConfirmations`.replace(`{${"carrier"}}`, encodeURIComponent(String(requestParameters.carrier))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async shippoCarrierApiControllerGetAllSignatureConfirmationsByShippoCarrier(requestParameters: ShippoCarrierApiControllerGetAllSignatureConfirmationsByShippoCarrierRequest): Promise<Array<GetAllSignatureConfirmationsByShippoCarrierPaResponse>> {
        const response = await this.shippoCarrierApiControllerGetAllSignatureConfirmationsByShippoCarrierRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async shippoCarrierApiControllerGetShippoCarriersRaw(): Promise<runtime.ApiResponse<Array<GetAllShippoCarriersResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/shippo-carriers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async shippoCarrierApiControllerGetShippoCarriers(): Promise<Array<GetAllShippoCarriersResponse>> {
        const response = await this.shippoCarrierApiControllerGetShippoCarriersRaw();
        return await response.value();
    }

    /**
     */
    async shippoCarrierApiControllerGetShippoCarriersAllInOneRaw(): Promise<runtime.ApiResponse<Array<GetAllShippoCarriersAllInOneResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/shippo-carriers-allinone`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async shippoCarrierApiControllerGetShippoCarriersAllInOne(): Promise<Array<GetAllShippoCarriersAllInOneResponse>> {
        const response = await this.shippoCarrierApiControllerGetShippoCarriersAllInOneRaw();
        return await response.value();
    }

}
